"use client"

import { useState } from "react"
import DashboardSidebar from "@/components/Dashboard/DashboardSidebar"
import DashboardHeader from "@/components/Dashboard/DashboardHeader"
import { cn } from "@/lib/utils"

export default function DashboardLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false) // arranca cerrado en mobile

  return (
    <div className="flex min-h-screen bg-[#F8F8F8]">
      {/* Backdrop para mobile */}
      <div
        className={cn(
          "fixed inset-0 bg-black/30 lg:hidden transition-opacity",
          sidebarOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        )}
        onClick={() => setSidebarOpen(false)} // 👈 tap fuera = cerrar sidebar
      />

      {/* Sidebar */}
      <DashboardSidebar open={sidebarOpen} setOpen={setSidebarOpen} />

      {/* Contenido */}
      <div className="flex flex-1 flex-col max-h-screen overflow-hidden">
        <DashboardHeader toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        <main className="flex-1 overflow-y-auto p-6">{children}</main>
      </div>
    </div>
  )
}
